import moment from 'moment'
import { IFileProps } from './File'
import { NoticeProperties } from '@/infrastructure/network/Monitaro/schema/models'

export interface INoticeProps {
  id?: string
  category: string | null
  title: string | null
  content: string | null
  properties: NoticeProperties | null
  files: IFileProps[] | null
  arrival: boolean
  publishedAt: string | null
  createdAt: string | null
  updatedAt: string | null
}

export default class NoticeEntity {
  private _props: INoticeProps

  constructor(props?: INoticeProps | null) {
    this._props = EmptyNoticePropsFactory(props)
  }

  get props(): INoticeProps {
    return this._props
  }

  get clone(): INoticeProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get category(): string | null {
    return this._props.category
  }

  get title(): string | null {
    return this._props.title
  }

  get content(): string | null {
    return this._props.content
  }

  get properties(): NoticeProperties | null | undefined {
    return this._props.properties
  }

  get files(): IFileProps[] {
    return this._props.files ?? []
  }

  get image(): string | null {
    const file = this.files[0]

    if (!file || !file.path || file.extension === 'pdf') {
      return '/assets/img/noimage.png'
    }

    // The path is already a complete URL from the API
    return file.path
  }

  get path(): string | null {
    const file = this.files[0]

    if (!file || !file.path) {
      return '/assets/img/noimage.png'
    }

    // The path is already a complete URL from the API
    return file.path
  }

  get to(): any {
    return !this._props.properties?.movie ? { name: 'notice-id', params: { id: this._props.id } } : undefined
  }

  get href(): any {
    return this._props.properties?.movie || undefined
  }

  get publishedAt(): string | null {
    return moment(this._props.publishedAt).format('YYYY年M月D日')
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyNoticePropsFactory = (props?: Partial<INoticeProps> | null): INoticeProps => ({
  category: null,
  title: null,
  content: null,
  properties: null,
  files: null,
  arrival: false,
  publishedAt: null,
  createdAt: null,
  updatedAt: null,
  ...props
})
